<template>
  <div>
    <NavBar />
    <Map />
    <div class="container bg-white shadow py-3">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import Map from "@/components/Map";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default {
  components: { Map, NavBar, Footer }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/ContentWithMap.vue